export const addProjectPrefix = <T extends Record<string, string>>(
  project: string,
  texts: T,
): { [K in keyof T]: string } =>
  Object.fromEntries(Object.entries(texts).map(([key, value]) => [key, `${project}:${value}`])) as {
    [K in keyof T]: string;
  };
